import {RepositoryNotLoading} from "./Repository";
import axios from 'axios';
import resource from '../../../../resources/resource';

const resource_v1 = 'v1';
const resource_v2 = 'v2';
export default {
    login(data) {
        return axios.post(`${resource.baseURL}${resource_v1}/authentication`, data, {headers: {accept: 'application/json'}});
    },
    register(data) {
        return axios.post(`${resource.baseURL}${resource_v2}/auth/register`, data, {headers: {accept: 'application/json'}});
    },
    userData() {
        return RepositoryNotLoading.get(`${resource_v1}/user-data`);
    }
}
